import { useEffect, useState } from 'react';
import { AMPLITUDE_EVENT_TYPES } from 'constants/amplitude';
import useAmplitude from 'utils/hooks/useAmplitude';
import {
  useApproveFundingRequest,
  useDeclineFundingRequest,
} from 'services/reactQueryHooks/fundingRequests';

const useFundingRequestsPage = () => {
  const { sendAmplitudeEvent } = useAmplitude();
  const [searchValue, setSearchValue] = useState('');
  const [activeTab, setActiveTab] = useState('pending');
  const [reviewingRequest, setReviewingRequest] = useState(null);

  // TEMPORARY: lets us flip between the empty state and the populated table using
  // mock data until real funding request data exists. Remove this toggle then.
  const [showData, setShowData] = useState(true);

  const { mutate: approveFundingRequest, isLoading: isApproving } = useApproveFundingRequest();
  const { mutate: declineFundingRequest, isLoading: isDeclining } = useDeclineFundingRequest();

  const handleCloseReview = () => setReviewingRequest(null);

  const handleApprove = (id, note) => {
    sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.fundingRequestApprove);
    approveFundingRequest({ id, note }, { onSuccess: handleCloseReview });
  };

  const handleDecline = (id, note) => {
    sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.fundingRequestDecline);
    declineFundingRequest({ id, note }, { onSuccess: handleCloseReview });
  };

  useEffect(() => {
    sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.fundingRequestsPage);
  }, [sendAmplitudeEvent]);

  return {
    searchValue,
    activeTab,
    reviewingRequest,
    showData,
    isApproving,
    isDeclining,
    onSearch: setSearchValue,
    onTabChange: setActiveTab,
    onReview: setReviewingRequest,
    onCloseReview: handleCloseReview,
    onToggleShowData: setShowData,
    onApprove: handleApprove,
    onDecline: handleDecline,
  };
};

export default useFundingRequestsPage;
